import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,Dialog, DialogContent, Typography, CircularProgress
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import tokenService from '../../../../utils/tokenDecoder';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import { LoadingComponent } from '../../../../utils/newLoader';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import tokenDecoder from '../../../../utils/tokenDecoder';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
}));

const screenCode = 'BLDETAILEDCALCULATIONSREPORT';

export default function DailyCropReport(props) {
  const [title, setTitle] = useState("BL Detailed Calculations Report");
  const classes = useStyles();
  const [dailyCropDetail, setDailyCropDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    productID: 0,
    year: '',
    month: '',
    dueDate: new Date().toISOString().substring(0, 10)

  });
  const [normalLeafRate, setNormalLeafRate] = useState('');
  const [superLeafRate, setSuperLeafRate] = useState('');
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routeList, setRouteList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const [dailyCropData, setDailyCropData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isStartBalanceExecute, setIsStartBalanceExecute] = useState(false);
  const [isExecutionCompleted, setIsExecutionCompleted] = useState(false);
  const [totals, setTotals] = useState([]);
  const [isReportViewed, setIsReportViewed] = useState(false);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    routeName: "0",
  })
  const [dissableFilters, setDissableFilters] = useState(false);
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();
  useEffect(() => {
    trackPromise(
      getPermission()
    );
    trackPromise(
      getGroupsForDropdown()
    );
    setValuesFromSession();
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown());
  }, [dailyCropDetail.groupID]);

  useEffect(() => {
    trackPromise(
      getRoutesByFactoryID(),
      getProductByFactoryID()
    )

    if (dailyCropDetail.factoryID > 0 && dailyCropDetail.groupID > 0) {
      trackPromise(GetBalancePaymentYearMonthForDropDown());
    }
  }, [dailyCropDetail.factoryID]);

  useEffect(() => {
    setDailyCropData([]);
    if (isReportViewed) {
      window.location.reload();
    }
  }, [dailyCropDetail, selectedDate]);

  useEffect(() => {
    if (dailyCropDetail.groupID > 0 && dailyCropDetail.factoryID > 0 && dailyCropDetail.productID > 0 && selectedDate !== null) {
      trackPromise(GetCollectionTypeBalanceRateDetails());
    }
  }, [selectedDate, dailyCropDetail.productID]);



  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWBLDETAILEDCALCULATIONSREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    const initialGroupID = tokenService.getGroupIDFromToken() ? parseInt(tokenService.getGroupIDFromToken()) : 0;
    const initialFactoryID = tokenService.getFactoryIDFromToken() ? parseInt(tokenService.getFactoryIDFromToken()) : 0;

    setDailyCropDetail(prev => ({
      ...prev,
      groupID: initialGroupID,
      factoryID: initialFactoryID
    }));
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(dailyCropDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    if (sessionStorage.getItem("BalanceRates") === null) {
      const routeList = await services.getRoutesForDropDown(dailyCropDetail.factoryID);
      const converted = Object.entries(routeList).map(([routeID, routeName]) => ({
        routeID: parseInt(routeID),
        routeName,
        normalLeafRate: '',
        superLeafRate: ''
      }));
      setRouteList(converted);
    }
  }

  async function getProductByFactoryID() {
    const product = await services.getAllProducts(dailyCropDetail.factoryID);
    setProductList(product);
  }

  async function GetDetails() {
    let cropData = {};
    if (sessionStorage.getItem("BalanceRates") !== null) {
      const balanceRates = JSON.parse(sessionStorage.getItem("BalanceRates"));

      let formattedDueDate = balanceRates.dueDate ? moment(balanceRates.dueDate).format('YYYY-MM-DD') : null;

      let model = {
        groupID: parseInt(balanceRates.groupID),
        factoryID: parseInt(balanceRates.factoryID),
        productID: parseInt(balanceRates.productID),
        applicableMonth: balanceRates.applicableMonth.toString(),
        applicableYear: balanceRates.applicableYear.toString(),
        dueDate: formattedDueDate,
        executionHistoryID: parseInt(balanceRates.executionHistoryID)
      };
      cropData = await services.GetBalancePaymentDetails(model);
      if (cropData.statusCode = "Success") {
        sessionStorage.removeItem("BalanceRates");
        setIsReportViewed(true);
      }
    } else {
      return;
    }
    const routeName = routeList.find(r => r.routeID === dailyCropDetail.routeID)?.routeName || "All Routes";

    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[dailyCropDetail.groupID] || "0",
      factoryName: FactoryList[dailyCropDetail.factoryID] || "0",
      routeName: routeName
    });

    // getSelectedDropdownValuesForReport(dailyCropDetail.groupID, dailyCropDetail.factoryID, dailyCropDetail.routeID);
    if (cropData.statusCode = "Success") {
      cropData.data.map(x => {
        x.trasport = x.transportRate;
        x.totalDeduction = (x.lastMonthBalance + x.thisMonthInstallments) + (x.tea) + (x.advance) + (x.loan) + (x.otherDeduction) + (x.stamp) + (x.cashBalanceBF) + (x.transportRate);
        x.amountToPay = ((x.amountDue + x.coinBF + x.otherAddition >= x.totalDeduction) ? Math.abs(x.amountDue - x.totalDeduction + x.coinBF + x.otherAddition) : 0);
        x.debitToFactory = ((x.amountDue + x.coinBF + x.otherAddition <= x.totalDeduction) ? Math.abs(x.amountDue + x.coinBF + x.otherAddition - x.totalDeduction) : 0);
        x.balance = ((x.amountToPay).toFixed(2));
        x.coinsCF = ((x.balance % 10).toFixed(2));
        x.amountToPayNew = ((x.amountDue + x.coinBF + x.otherAddition >= x.totalDeduction) ? (x.balance - x.coinsCF).toFixed(2) : 0);
        x.totalToDeduct = (x.lastMonthBalance) + (x.thisMonthInstallments);
      });

      let totalModel = [];
      let totalNLQty = 0; let totalNLGross = 0; let totalSLQty = 0; let totalSLGross = 0; let totalLeaf = 0; let totalAmountDue = 0; let totalBFCoins = 0; let totalAddition = 0; let totalLMB = 0;
      let totalTMTI = 0; let totalTMI = 0; let totalTTD = 0; let totalTea = 0; let totalCBBF = 0; let totalAdvance = 0; let totalTransport = 0; let totalStamp = 0; let totalLoan = 0;
      let totalOtherDeduction = 0; let totalDeduction = 0; let totalATP = 0; let totalTDTF = 0; let totalCFCoins = 0; let totalBalance = 0;
      let totalapprovedAmount = 0;
      cropData.data.map(x => {
        totalNLQty += x.normalLeaf; totalModel.totalNLQty = totalNLQty.toFixed(2);
        totalNLGross += x.normalLeafGross; totalModel.totalNLGross = totalNLGross.toFixed(2);
        totalSLQty += x.superLeaf; totalModel.totalSLQty = totalSLQty.toFixed(2);
        totalSLGross += x.superLeafGross; totalModel.totalSLGross = totalSLGross.toFixed(2);
        totalLeaf += x.leafTotal; totalModel.totalLeaf = totalLeaf.toFixed(2);
        totalAmountDue += x.amountDue; totalModel.totalAmountDue = totalAmountDue.toFixed(2);
        totalBFCoins += x.coinBF; totalModel.totalBFCoins = totalBFCoins.toFixed(2);
        totalAddition += x.otherAddition; totalModel.totalAddition = totalAddition.toFixed(2);
        totalLMB += x.lastMonthBalance; totalModel.totalLMB = totalLMB.toFixed(2);
        totalTMTI += x.thisMonthTotalIssued; totalModel.totalTMTI = totalTMTI.toFixed(2);
        totalTMI += x.thisMonthInstallments; totalModel.totalTMI = totalTMI.toFixed(2);
        totalTTD += x.totalToDeduct; totalModel.totalTTD = totalTTD.toFixed(2);
        totalTea += x.tea; totalModel.totalTea = totalTea.toFixed(2);
        totalCBBF += x.cashBalanceBF; totalModel.totalCBBF = totalCBBF.toFixed(2);
        totalAdvance += x.advance; totalModel.totalAdvance = totalAdvance.toFixed(2);
        totalTransport += x.transportRate; totalModel.totalTransport = totalTransport.toFixed(2);
        totalStamp += x.stamp; totalModel.totalStamp = totalStamp.toFixed(2);
        totalLoan += x.loan; totalModel.totalLoan = totalLoan.toFixed(2);
        totalOtherDeduction += x.otherDeduction; totalModel.totalOtherDeduction = totalOtherDeduction.toFixed(2);
        totalDeduction += x.totalDeduction; totalModel.totalDeduction = totalDeduction.toFixed(2);
        totalATP += parseFloat(x.amountToPayNew); totalModel.totalATP = totalATP.toFixed(2);
        totalTDTF += x.debitToFactory; totalModel.totalTDTF = totalTDTF.toFixed(2);
        totalCFCoins += ((x.coinsCF * 10) / 10); totalModel.totalCFCoins = parseFloat(totalCFCoins);
        //totalBalance += Math.trunc(x.balance); totalModel.totalBalance = totalBalance;
        totalBalance += parseFloat(x.balance); totalModel.totalBalance = totalBalance.toFixed(2);
        totalapprovedAmount += parseFloat(x.approvedAmount); totalModel.totalapprovedAmount = totalapprovedAmount.toFixed(2);
      })
      setDailyCropData(cropData.data);
      setTotals(totalModel);
      setDissableFilters(false);
    }
    else {
      alert.error("No records to display");
    }
  }

  async function createDataForExcel(array) {
    var aoa = [];

    if (array != null) {
      const groupedData = groupDataByRoute(array);
      const routeKeys = Object.keys(groupedData);

      aoa.push([
        '', '', '', '', '', '', '', '', '',
        'EARNINGS', '', '',
        'FERTILIZER', '', '', '',
        'CASH ADVANCE & OTHER RECOVERIES', '', '', '', '', '', '', '',
        'FINAL BALANCE', '', '', '', '',
        //'DUE CHEQUES DETAILS', '', ''
      ]);

      aoa.push([
        'Reg No', 'Name', 'NL QTY', 'NL Rate', 'NL Gross', 'SL QTY', 'SL Rate', 'SL Gross', 'LEAF TOTAL',
        'AMOUNT DUE', 'COINS B/F', 'OTHER ADDITION',
        'LAST MONTH BALANCE', 'THIS MONTH TOTAL ISSUED', 'THIS MONTH INSTALLMENT', 'TOTAL TO DEDUCT',
        'TEA', 'CASH BALANCE B/F', 'ADVANCE', 'TRANSPORT', 'STAMP', 'LOAN', 'OTHER DEDUCT.', 'TOTAL DEDUCT.',
        'AMOUNT TO PAY', 'TOTAL DEBIT TO FACTORY',
        'COINS C/F', 'BALANCE ', 'PAY. MODE'//, 'DUE DATE', 'CHEQUE NUMBER', 'AMOUNT'

      ]);

      routeKeys.forEach(routeKey => {
        const routeName = getRouteName(parseInt(routeKey));

        aoa.push([
          `ROUTE: ${routeName}`, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
        ]);

        groupedData[routeKey].forEach(x => {
          aoa.push([
            x.registrationNumber,
            x.customerName,
            parseFloat(x.normalLeaf) || 0,
            parseFloat(x.normalLeafRate) || 0,
            parseFloat(x.normalLeafGross) || 0,
            parseFloat(x.superLeaf) || 0,
            parseFloat(x.superLeafRate) || 0,
            parseFloat(x.superLeafGross) || 0,
            parseFloat(x.leafTotal) || 0,
            parseFloat(x.amountDue) || 0,
            parseFloat(x.coinBF) || 0,
            parseFloat(x.otherAddition) || 0,
            parseFloat(x.lastMonthBalance) || 0,
            parseFloat(x.thisMonthTotalIssued) || 0,
            parseFloat(x.thisMonthInstallments) || 0,
            parseFloat(x.totalToDeduct) || 0,
            parseFloat(x.tea) || 0,
            parseFloat(x.cashBalanceBF) || 0,
            parseFloat(x.advance) || 0,
            parseFloat(x.trasport) || 0,
            parseFloat(x.stamp) || 0,
            parseFloat((x.loan).toFixed(2)) || 0,
            parseFloat(x.otherDeduction) || 0,
            parseFloat(x.totalDeduction) || 0,
            parseFloat(x.amountToPayNew) || 0,
            parseFloat(x.debitToFactory) || 0,
            parseFloat(x.coinsCF) || 0,
            parseFloat(x.balance) || 0,
            x.paymentMethodName || ''
            // x.dueDate ? moment(x.dueDate).format('YYYY-MM-DD') : '-',
            // x.chequeNumber || '-',
            // parseFloat(x.approvedAmount) || 0
          ]);
        });

        if (routeKey !== routeKeys[routeKeys.length - 1]) {

          aoa.push(['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']);
        }
      });

      aoa.push([
        'TOTALS', '',
        parseFloat(totals.totalNLQty) || 0, '',
        parseFloat(totals.totalNLGross) || 0,
        parseFloat(totals.totalSLQty) || 0, '',
        parseFloat(totals.totalSLGross) || 0,
        parseFloat(totals.totalLeaf) || 0,
        parseFloat(totals.totalAmountDue) || 0,
        parseFloat(totals.totalBFCoins) || 0,
        parseFloat(totals.totalAddition) || 0,
        parseFloat(totals.totalLMB) || 0,
        parseFloat(totals.totalTMTI) || 0,
        parseFloat(totals.totalTMI) || 0,
        parseFloat(totals.totalTTD) || 0,
        parseFloat(totals.totalTea) || 0,
        parseFloat(totals.totalCBBF) || 0,
        parseFloat(totals.totalAdvance) || 0,
        parseFloat(totals.totalTransport) || 0,
        parseFloat(totals.totalStamp) || 0,
        parseFloat(totals.totalLoan) || 0,
        parseFloat(totals.totalOtherDeduction) || 0,
        parseFloat(totals.totalDeduction) || 0,
        parseFloat(totals.totalATP) || 0,
        parseFloat(totals.totalTDTF) || 0,
        parseFloat(totals.totalCFCoins) || 0,
        parseFloat(totals.totalBalance) || 0,
        '',
        '',
        '',
        parseFloat(totals.totalapprovedAmount) || 0
      ]);


      aoa.push(['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']);

      aoa.push([
        'Group : ' + selectedSearchValues.groupName,
        'Factory : ' + selectedSearchValues.factoryName,
        '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
      ]);

      aoa.push([
        `Route : ${selectedSearchValues.routeName ? selectedSearchValues.routeName : "All Routes"}`,
        'Month : ' + moment(selectedDate).format('MMMM - YYYY'),
        '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
      ]);
    }
    return aoa;
  }

  async function createFile() {
    var aoa = await createDataForExcel(dailyCropData);
    const worksheet = XLSX.utils.aoa_to_sheet(aoa);

    var merges = [];

    merges.push({
      s: { r: 0, c: 9 },
      e: { r: 0, c: 11 }
    })
    merges.push({
      s: { r: 0, c: 12 },
      e: { r: 0, c: 15 }
    });
    merges.push({
      s: { r: 0, c: 16 },
      e: { r: 0, c: 23 }
    });
    merges.push({
      s: { r: 0, c: 24 },
      e: { r: 0, c: 26 }
    });

    worksheet['!merges'] = merges;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'BL Detailed Calculations Report');

    const fileName = selectedSearchValues.routeName && selectedSearchValues.routeName !== "0"
      ? `BL Detailed Calculations Report - ${selectedSearchValues.factoryName} - ${selectedSearchValues.routeName} - ${moment(selectedDate).format('MMMM-YYYY')}.xlsx`
      : `BL Detailed Calculations Report - ${selectedSearchValues.factoryName} - All Routes - ${moment(selectedDate).format('MMMM-YYYY')}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  }

  function groupDataByRoute(data) {
    const grouped = {};
    data.forEach(item => {
      const routeKey = item.routeID || 'No Route';
      if (!grouped[routeKey]) {
        grouped[routeKey] = [];
      }
      grouped[routeKey].push(item);
    });
    return grouped;
  }

  function getRouteName(routeID) {
    if (routeID === 0 || !routeID) return 'No Route';
    const route = routeList.find(item => item.routeID == routeID);
    return route.routeName;
  }

  function getSelectedDropdownValuesForReport(groupID, factoryID, routeID) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[groupID],
      factoryName: FactoryList[factoryID],
      routeName: routeList[routeID]
    })
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setDailyCropDetail({
      ...dailyCropDetail,
      [e.target.name]: value
    });
    setDailyCropData([]);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  function handleDateChange(date) {
    var month = date.getUTCMonth() + 1;
    var year = date.getUTCFullYear();
    var currentmonth = moment().format('MM');

    if (selectedDate != null) {
      var prevMonth = selectedDate.getUTCMonth() + 1
      var prevyear = selectedDate.getUTCFullYear();

      if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
        setSelectedDate(date)
      }
    } else {
      setSelectedDate(date)
    }
  }

  async function CalculateBalanceRateDetails() {

    let formattedDueDate = null;
    if (dailyCropDetail.dueDate) {
      formattedDueDate = moment(dailyCropDetail.dueDate).format('YYYY-MM-DD');
    }
    let model = {
      groupID: parseInt(dailyCropDetail.groupID),
      factoryID: parseInt(dailyCropDetail.factoryID),
      productID: parseInt(dailyCropDetail.productID),
      applicableDate: moment(selectedDate).format(),
      applicableMonth: (selectedDate.getMonth() + 1).toString().padStart(2, '0'),
      applicableYear: selectedDate.getFullYear().toString(),
      dueDate: formattedDueDate,
      createdBy: tokenDecoder.getUserIDFromToken(),
      routeRateList: routeList.map(route => ({
        routeID: route.routeID,
        routeName: route.routeName,
        normalLeafRate: parseFloat(route.normalLeafRate),
        superLeafRate: parseFloat(route.superLeafRate)
      }))
    };
    var response = await services.CalculateBalanceRateDetail(model);

    if (response.statusCode === "Success") {
      const data = {
        ...response.data,
        dueDate: dailyCropDetail.dueDate
      };
      alert.success("Saved Successfully");
      setIsStartBalanceExecute(true);
      setDissableFilters(true);
      sessionStorage.setItem('BalanceRates', JSON.stringify(data));
    }
  }

  async function GetBalancePaymentYearMonthForDropDown() {
    if (sessionStorage.getItem("BalanceRates") === null) {
      var response = await services.GetBalancePaymentYearMonth(dailyCropDetail.groupID, dailyCropDetail.factoryID);

      const applicableYear = parseInt(response.applicableYear);
      const applicableMonth = parseInt(response.applicableMonth) - 1;

      const date = new Date(applicableYear, applicableMonth);

      setSelectedDate(date);
    }
  };

  function setValuesFromSession() {
    if (sessionStorage.getItem("BalanceRates") !== null) {
      setDissableFilters(true);
      setIsStartBalanceExecute(true);

      const balanceRates = JSON.parse(sessionStorage.getItem("BalanceRates"));
      trackPromise(getExecutionStatus(balanceRates.executionHistoryID));

      setDailyCropDetail({
        ...dailyCropDetail,
        groupID: balanceRates.groupID,
        factoryID: balanceRates.factoryID,
        routeID: balanceRates.routeID,
        productID: balanceRates.productID,
        dueDate: balanceRates.dueDate
      });

      setRouteList(balanceRates.routeRateList);
      let date = new Date(balanceRates.applicableDate)
      setSelectedDate(date);
    }
  }

  async function getExecutionStatus(executionHistoryID) {
    const response = await services.getExecutionStatus(executionHistoryID);
    if (response.statusCode === 'Success' && response.data === 3) {
      setIsExecutionCompleted(true);
      return true;
    }
    return false;
  }

   useEffect(() => {
    let intervalId = null;
    if (isStartBalanceExecute && !isExecutionCompleted) {
      intervalId = setInterval(async () => {
        const balanceRates = sessionStorage.getItem("BalanceRates");
        if (balanceRates) {
          const parsed = JSON.parse(balanceRates);
          const completed = await getExecutionStatus(parsed.executionHistoryID);
          if (completed) {
            clearInterval(intervalId);
          }
        }
      }, 5000);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [isStartBalanceExecute, isExecutionCompleted]);

  function handleNormalLeafRateChange(e) {
    const value = e.target.value;
    setNormalLeafRate(value);

    const updatedRoutes = routeList.map((route) => ({
      ...route,
      normalLeafRate: value,
    }));
    setRouteList(updatedRoutes);
  };

  function handleSuperLeafRateChange(e) {
    const value = e.target.value;
    setSuperLeafRate(value);

    const updatedRoutes = routeList.map((route) => ({
      ...route,
      superLeafRate: value,
    }));
    setRouteList(updatedRoutes);
  };

  async function GetCollectionTypeBalanceRateDetails() {
    const balanceRateDetails = await services.GetCollectionTypeBalanceRateDetails(dailyCropDetail.groupID, dailyCropDetail.factoryID, dailyCropDetail.productID, selectedDate);

    const grouped = {};

    balanceRateDetails.blanaceRates.forEach(item => {
      const { routeID, routeName, collectionTypeName, rate, executionStatusID } = item;

      if (!grouped[routeID]) {
        grouped[routeID] = {
          routeID: routeID,
          routeName: routeName,
          superLeafRate: 0,
          normalLeafRate: 0,
          executionStatusID: executionStatusID
        };
      }

      if (collectionTypeName === "Super Leaf") {
        grouped[routeID].superLeafRate = rate;
      } else if (collectionTypeName === "Normal Leaf") {
        grouped[routeID].normalLeafRate = rate;
      }
    });

    const finalArray = Object.values(grouped);
    setRouteList(finalArray);
  }

  const getPageMargins = () => {
    return `@media print {
    @page {
      size: A3 Landscape;
      margin: 0mm; 
    }

    body {
        transform: scale(1, 1);
        transform-origin: top left;
        background-color: white !important;
        width: 100%;
    }
  }`;
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: dailyCropDetail.groupID,
              factoryID: dailyCropDetail.factoryID,
              routeID: dailyCropDetail.routeID,
              productID: dailyCropDetail.productID,
              selectedDate: selectedDate,
              dueDate: dailyCropDetail.dueDate
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                selectedDate: Yup.date().required('Select applicable month').nullable(),
                dueDate: Yup.date().nullable()
              })
            }
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          {/* <Grid item md={3} xs={ 8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              size='small'
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={dailyCropDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled || dissableFilters}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              size='small'
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={dailyCropDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled || dissableFilters}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid> */}




                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={dailyCropDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={dailyCropDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="productID">
                              Product
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.productID && errors.productID)}
                              fullWidth
                              helperText={touched.productID && errors.productID}
                              size='small'
                              name="productID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={dailyCropDetail.productID}
                              variant="outlined"
                              id="productID"
                              disabled={dissableFilters}
                            >
                              <MenuItem value="0">--Select Product--</MenuItem>
                              {generateDropDownMenu(productList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                error={Boolean(touched.selectedDate && errors.selectedDate)}
                                fullWidth
                                helperText={touched.selectedDate && errors.selectedDate}
                                autoOk
                                variant="inline"
                                openTo="month"
                                views={["year", "month"]}
                                label="Year and Month *"
                                value={selectedDate}
                                onChange={(date) => handleDateChange(date)}
                                size='small'
                                disabled={dissableFilters}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="date">
                              Due  Date
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.dueDate && errors.dueDate)}
                              fullWidth
                              helperText={touched.dueDate && errors.dueDate}
                              size='small'
                              name="dueDate"
                              type="date"
                              onChange={(e) => handleChange(e)}
                              value={dailyCropDetail.dueDate}
                              variant="outlined"
                              id="dueDate"
                            />
                          </Grid>

                        </Grid>
                        <br>
                        </br>
                        <br>
                        </br>

                        {dissableFilters == false ?
                          routeList.length !== 0 && !isReportViewed ? (
                            <Box minWidth={950}>
                              <TableContainer component={Paper} style={{ maxHeight: '550px', overflowY: 'auto' }}>
                                <Table size="small" stickyHeader>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell colSpan={1} style={{ fontWeight: 'bold', fontSize: '12px', padding: '5px' }}>
                                        Route
                                      </TableCell>
                                      <TableCell style={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'right' }}>
                                        Normal Leaf Rate
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          value={normalLeafRate}
                                          onChange={handleNormalLeafRateChange}
                                          inputProps={{ style: { fontSize: '12px', textAlign: 'right' } }}
                                          disabled={dissableFilters}
                                        />
                                      </TableCell>
                                      <TableCell style={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'right' }}>
                                        Super Leaf Rate
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          value={superLeafRate}
                                          onChange={handleSuperLeafRateChange}
                                          inputProps={{ style: { fontSize: '12px', textAlign: 'right' } }}
                                          disabled={dissableFilters}
                                        />
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {routeList.map((route, index) => (
                                      <TableRow key={route.routeID}>
                                        <TableCell style={{ fontSize: '12px' }}>{route.routeName}</TableCell>

                                        <TableCell style={{ fontSize: '12px', textAlign: 'right' }}>
                                          <TextField
                                            value={route.normalLeafRate || ''}
                                            onChange={(e) => {
                                              const updated = [...routeList];
                                              updated[index] = {
                                                ...updated[index],
                                                normalLeafRate: e.target.value,
                                              };
                                              setRouteList(updated);
                                            }}
                                            variant="outlined"
                                            size="small"
                                            inputProps={{ style: { fontSize: '12px', textAlign: 'right' } }}
                                            disabled={dissableFilters || route.executionStatusID === 3}
                                          />
                                        </TableCell>

                                        <TableCell style={{ fontSize: '12px', textAlign: 'right' }}>
                                          <TextField
                                            value={route.superLeafRate || ''}
                                            onChange={(e) => {
                                              const updated = [...routeList];
                                              updated[index] = {
                                                ...updated[index],
                                                superLeafRate: e.target.value,
                                              };
                                              setRouteList(updated);
                                            }}
                                            variant="outlined"
                                            size="small"
                                            inputProps={{ style: { fontSize: '12px', textAlign: 'right' } }}
                                            disabled={dissableFilters || route.executionStatusID === 3}
                                          />
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Box>
                          ) : null
                          : null}
                        {
                          isExecutionCompleted === false ?
                            <Box display="flex" flexDirection="column" alignItems="flex-end" p={2}>
                              <Button
                                color="primary"
                                disabled={isStartBalanceExecute}
                                type="submit"
                                variant="contained"
                                onClick={() => trackPromise(CalculateBalanceRateDetails())}
                              >
                                {isStartBalanceExecute ? "Pending" : "Estimate Balance Payment"}
                              </Button>
                               <Dialog
                                open={isStartBalanceExecute && !isExecutionCompleted}
                                PaperProps={{
                                  style: {
                                    padding: '30px 40px',
                                    textAlign: 'center',
                                    borderRadius: 12
                                  }
                                }}
                              >
                                <DialogContent style={{ textAlign: 'center' }}>
                                  <Typography variant="h5" style={{ color: '#1b00a4ff', fontWeight: 'bold', marginBottom: 10 }}>
                                    Please Wait!
                                  </Typography>
                                  <Typography variant="body1" style={{ marginBottom: 20 }}>
                                    Background Process Running...
                                  </Typography>
                                  <CircularProgress style={{ color: '#1b00a4ff' }} size={50} />
                                </DialogContent>
                              </Dialog>
                            </Box>
                            :
                            <Box display="flex" justifyContent="flex-end" p={2}>
                              <Button
                                color="primary"
                                variant="contained"
                                onClick={() => trackPromise(GetDetails())}
                              >
                                View Report
                              </Button>
                            </Box>
                        }

                        {dailyCropData.length != 0 ?
                          <Box minWidth={950} >
                            <TableContainer component={Paper} style={{ maxHeight: '550px', overflowY: 'auto' }}>
                              <Table size="small" aria-label="sticky table" Table stickyHeader>
                                <TableHead>
                                  <TableRow>
                                    <TableCell colSpan={2} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '5px', zIndex: 3 }}></TableCell>
                                    <TableCell colSpan={7} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '5px' }}></TableCell>
                                    <TableCell colSpan={3} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '5px' }} align="center">EARNINGS</TableCell>
                                    <TableCell colSpan={4} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '5px' }} align="center">FERTILIZER</TableCell>
                                    <TableCell colSpan={7} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '5px' }} align="center">CASH ADVANCE & OTHER RECOVERIES</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '5px' }}></TableCell>
                                    <TableCell colSpan={2} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '5px' }} align="center">FINAL BALANCE</TableCell>
                                    <TableCell colSpan={3} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '5px' }}></TableCell>
                                    {/* <TableCell colSpan={3} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '5px' }} align="center">DUE CHEQUES DETAILS</TableCell> */}


                                  </TableRow>
                                  <TableRow>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', left: 0, zIndex: 4, position: 'sticky' }}>REG.NO.</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', left: 52, zIndex: 4, position: 'sticky' }}>NAME</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>NL QTY (kg)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>NL RATE (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>NL GROSS (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>SL QTY (kg)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>SL RATE (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>SL GROSS (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>LEAF TOTAL (kg)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>AMOUNT DUE (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>COINS B/F (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>OTHER ADDITION (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>LAST MONTH BALANCE (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>THIS MONTH TOTAL ISSUED (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>THIS MONTH INSTALLMENT (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>TOTAL TO DEDUCT (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>TEA (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>CASH BALANCE B/F (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>ADVANCE (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>TRANSPORT RT (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>STAMP (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>LOAN (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>OTHER DEDUCT. (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>TOTAL DEDUCT. (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>AMOUNT TO PAY (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>TOTAL DEBIT TO FACTORY (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>COINS C/F (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>BALANCE (Rs.)</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>PAY. MODE</TableCell>
                                    {/* <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>Due  Date</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>Cheque Number</TableCell>
                                    <TableCell style={{ top: 35.5, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 3 }}>Amount</TableCell> */}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {(() => {
                                    const groupedData = groupDataByRoute(dailyCropData);
                                    const routeKeys = Object.keys(groupedData);

                                    return routeKeys.map(routeKey => (
                                      <React.Fragment key={routeKey}>
                                        <TableRow>
                                          <TableCell colSpan={10} style={{ borderTop: "1px solid black", borderLeft: "1px solid black", borderBottom: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '8px', textAlign: 'left', left: 0, zIndex: 2, position: 'sticky', backgroundColor: 'white' }}>
                                            ROUTE: {getRouteName(parseInt(routeKey))}
                                          </TableCell>
                                          <TableCell colSpan={19} style={{ borderTop: "1px solid black", borderRight: "1px solid black", borderBottom: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }}></TableCell>
                                        </TableRow>
                                        {groupedData[routeKey].map((row, index) => (
                                          <TableRow key={`${routeKey}-${index}`}>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', left: 0, zIndex: 2, position: 'sticky', backgroundColor: 'white' }}>{row.registrationNumber}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', left: 52, zIndex: 2, position: 'sticky', backgroundColor: 'white' }}>{row.customerName}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.normalLeaf).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.normalLeafRate).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.normalLeafGross).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.superLeaf).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.superLeafRate).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.superLeafGross).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.leafTotal).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.amountDue).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.coinBF).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.otherAddition).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.lastMonthBalance).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.thisMonthTotalIssued).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.thisMonthInstallments).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.totalToDeduct).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.tea).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.cashBalanceBF).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.advance).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.trasport).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.stamp).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.loan).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.otherDeduction).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.totalDeduction).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.amountToPayNew).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px', zIndex: 1 }} align='right'>{(parseFloat(row.debitToFactory).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }} align='right'>{(parseFloat(row.coinsCF).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }} align='right'>{(parseFloat(row.balance).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{row.paymentMethodName}</TableCell>
                                            {/* <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{
                                              row.chequeNumber &&
                                                row.dueDate &&
                                                !row.dueDate.startsWith("0001-01-01")
                                                ? row.dueDate.split("T")[0]
                                                : "-"
                                            }</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{row.chequeNumber ? (row.chequeNumber) : "-"}</TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }} align='right'>{row.chequeNumber ? (parseFloat(row.approvedAmount).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"}</TableCell> */}
                                          </TableRow>
                                        ))}
                                      </React.Fragment>
                                    ));
                                  })()}
                                </TableBody>
                                <TableRow>
                                  <TableCell colSpan={2} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', left: 0, zIndex: 2, position: 'sticky', backgroundColor: 'white', textAlign: "center" }}>Total</TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalNLQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }}> </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalNLGross).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalSLQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }}> </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalSLGross).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalLeaf).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  {/* EARNINGS */}
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalAmountDue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalBFCoins).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalAddition).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  {/* FERTILIZER */}
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalLMB).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalTMTI).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalTMI).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalTTD).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  {/* CASH ADVANCE & OTHER RECOVERIES */}
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalTea).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalCBBF).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalAdvance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalTransport).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalStamp).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalLoan).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalOtherDeduction).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  {/* // */}
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalDeduction).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  {/* FINAL BALANCE */}
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalATP).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalTDTF).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  {/* // */}
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalCFCoins).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalBalance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                  <TableCell colSpan={4} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }}> </TableCell>
                                  {/* <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px', zIndex: 1 }} align='right'> {parseFloat(totals.totalapprovedAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell> */}
                                </TableRow>
                              </Table>
                            </TableContainer>
                          </Box> : null}
                      </CardContent>
                      <Divider />
                      {dailyCropData.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={
                              selectedSearchValues.routeName && selectedSearchValues.routeName !== "0"
                                ? `BL Detailed Calculations Report - ${selectedSearchValues.factoryName} - ${selectedSearchValues.routeName} - ${moment(selectedDate).format('MMMM-YYYY')}`
                                : `BL Detailed Calculations Report - ${selectedSearchValues.factoryName} - All Routes - ${moment(selectedDate).format('MMMM-YYYY')}`
                            }
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                            >
                              PDF
                            </Button>}
                            content={() => componentRef.current}
                            pageStyle={getPageMargins()}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              dailyCropData={dailyCropData}
                              searchData={selectedSearchValues}
                              totals={totals}
                              dailyCropDetail={dailyCropDetail}
                              routeList={routeList}
                              selectDate={selectedDate}
                            />
                          </div>
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  )
}
